import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export const StyledBellButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.grey[600],
  transition: 'background-color 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    fontSize: '0.7rem',
    fontWeight: 600,
    borderRadius: '50%',
    padding: 0,
  },
}));
